import { useEffect, RefObject } from 'react';
import { NavTheme } from '../context/NavContext';

export function useNavTheme(ref: RefObject<Element | null>, theme: NavTheme) {
  useEffect(() => {
    if (ref.current) {
      ref.current.setAttribute('data-nav-theme', theme);
    }
  }, [ref, theme]);
}
